<template>
  <div>
    <template v-if="ipAddressList.length === 0">any</template>
    <template v-else>
      <div v-for="(srcAddress, i) in sortedIpAddressList" :key="i">
        {{ srcAddress.ipAddressName || srcAddress.ipAddress }}
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { IntraPolicy } from "@/apis/IntranetfwPolicyApi";

/** ポリシー設定(イントラネットFW)の送信元アドレスを表示するコンポーネント */
export default defineComponent({
  name: "PolicyIntranetSrcAddress",
  props: {
    /** 送信元アドレスリスト */
    ipAddressList: {
      type: Array as PropType<IntraPolicy["srcAddressList"]>,
      required: true,
    },
  },
  computed: {
    /**
     * ソート済みの送信元アドレスを返却する
     * アドレス名・アドレスの昇順
     */
    sortedIpAddressList(): IntraPolicy["srcAddressList"] {
      return this.ipAddressList.sortBy([
        (e) => e.ipAddressName ?? e.ipAddress,
        "asc",
      ]);
    },
  },
});
</script>
